<template>
  <ihris-element :edit="edit" :loading="loading">
    <template #form>
      <v-select
          v-model="valueCode"
          :disabled="disabled"
          :error-messages="errors"
          :items="items.filter(x => !x.code.includes('(deactivated)'))"
          :label="display"
          :loading="loading"
          :rules="rules"
          dense
          hide-details="auto"
          item-text="display"
          item-value="code"
          outlined
          @change="errors = []"
      >
        <template #label>{{ display }} <span v-if="required" class="red--text font-weight-bold">*</span></template>
      </v-select>
    </template>
    <template #header>
      {{ display }}
    </template>
    <template #value>
      {{ valueDisplay || value.display || "" }}
    </template>
  </ihris-element>
</template>

<script>
import IhrisElement from "../ihris/ihris-element.vue"

/*
const itemSort = (a,b) => {
  return (a.display === b.display ? (a.code === b.code ? 0 : (a.code < b.code ? -1: 1)) : (a.display < b.display ? -1 : 1) )
}
*/
export default {
  name: "fhir-coding",
  props: ["field", "label", "sliceName", "targetprofile", "min", "max", "base-min", "base-max", "slotProps", "path", "binding", "edit", "readOnlyIfSet",
    "constraints"],
  components: {
    IhrisElement
  },
  data: function () {
    return {
      value: {system: "", code: "", display: ""},
      valueCode: "",
      valueDisplay: "",
      loading: true,
      errors: [],
      //error: false,
      items: [],
      source: {path: "", data: {}, binding: this.binding},
      disabled: false,
      lockWatch: false
    }
  },
  created: function () {
    this.setupData()
  },
  watch: {
    slotProps: {
      handler() {
        if (!this.lockWatch) {
          this.setupData()
        }
      },
      deep: true
    },
    valueCode: function (code) {
      let tempValue = this.items.find((item) => item.code === code);
      if (
          tempValue &&
          tempValue.system ===
          "http://ihris.org/fhir/CodeSystem/ihris-profession-category-codesystem"
          && this.$route.params.page != 'job'
      ) {
        this.$fhirutils
            .expandOnDemand(code)
            .then((items) => {
              this.$root.$emit("loadedData", items);
            })
            .catch((err) => {
              console.log(err);
              //this.error = true
              this.errors.push(err.message);
              this.loading = false;
            });
      }
      if (this.items) {
        let findValue = this.items.find(item => item.code === code)
        if(this.binding === "http://ihris.org/fhir/ValueSet/ihris-salary-scale-valueset"){
          fetch("/fhir/CodeSystem/ihris-salary-scale-codesystem",{
            method: "GET",
          }).then(response =>{
            if(response.ok){
              response.json().then(data =>{
                let salary =  data.concept.find(x => x.code === this.value.code)?.property.find(x => x.code === "value")?.valueString
                this.$root.$emit("salaryScaleIsSelected", salary);
              })}})
        }
        if (findValue) {
          this.value = findValue
        }
      }
      if (this.value.system && this.value.code) {
        this.$fhirutils.codeLookup(this.value.system, this.value.code, this.binding || this.source.binding).then(display => {
          this.valueDisplay = display
        })
      }
    }
  },
  methods: {
    setupData: function () {
      if (this.slotProps && this.slotProps.source) {
        this.source = {
          path: this.slotProps.source.path + "." + this.field, data: {},
          binding: this.binding || this.slotProps.source.binding
        }
        if (this.slotProps.source.fromArray) {
          this.source.data = this.slotProps.source.data
          // Need to see if this works and figure out what it needs to be
          if (this.source.data) {
            this.value = this.source.data
            this.valueCode = this.value.code
            this.lockWatch = true

          }
        } else {

          let expression = this.$fhirutils.pathFieldExpression(this.field)
          this.source.data = this.$fhirpath.evaluate(this.slotProps.source.data, expression)
          //console.log("FPATH info",this.path,this.slotProps)
          //console.log("FPATH setting value to",this.field,this.source.data[0],expression,this.slotProps.source.data)
          if (this.source.data[0]) {
            this.value = this.source.data[0]
            this.valueCode = this.value.code
            this.lockWatch = true
          }
        }
        this.disabled = this.readOnlyIfSet && (!!this.valueCode)
      }
      let binding = this.binding || this.slotProps.source.binding
      if (binding === "http://ihris.org/fhir/ValueSet/ihris-job-ethiopia") {
        this.items = [];
        this.loading = false;
        this.$root.$on("loadedData", (data) => {
          this.items = [];
          this.items = data;
          this.loading = false;
        });
      } else {
        this.$fhirutils.expand(binding).then(items => {
          this.items = items
          this.loading = false
        }).catch(err => {
          console.log(err)
          //this.error = true
          this.errors = err.message
          this.loading = false
        })
      }
    }
  },
  computed: {
    index: function () {
      if (this.slotProps && this.slotProps.input) return this.slotProps.input.index
      else return undefined
    },
    display: function () {
      if (this.slotProps && this.slotProps.input) return this.slotProps.input.label
      else return this.label
    },
    required: function () {
      return (this.index || 0) < this.min
    },
    rules: function () {
      if (this.required) {
        return [v => !!v || this.display + " is required"]
      } else {
        return []
      }
    }
    /*
    displayValue: function() {
      let found = this.items.find( item => item.code === this.valueCode )
      if ( found ) {
        return found.display
      } else {
        return ""
      }
    }
    */
  }
}
</script>
